import { Button } from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import en from '../../../../lang/en-us';
import { TableColumn, TableWithCollapse } from '../../../../lib/DataTable';
import { useTableWithCollapse } from '../../../../lib/DataTable/customHooks';
import { getPortfolio } from '../../../../redux-store/actions/portfolio';
import {
    IsAllow,
    PORTFOLIO_RESPONSE_PAYLOAD,
    SCHEMES_RESPONSE,
} from '../../../../redux-store/types/portfolio';
import { SWITCH } from '../../../../utils/constants';
import { formatAsIndianCurrency } from '../../../../utils/currency';
import { getMatchAndUnMatchedFunds } from '../../../../utils/utilityFunctions';
import { NomineeStatusError, NomineeStatusErrorRef } from '../../../common/NomineeStatusError';
import { DividendTableRowType } from '../../makeNct/ChangeIdcw';
import NoFoliosFound from '../../makeNct/NoFoliosFound';
import { getDividendFilteredData, getErrorMessage } from '../../portfolios/utils';
import { ActionHeader, FaqLink } from '../index';
import { CommercialRootPath } from '../routeConfig';
import { SwitchPaths } from './types';
import { switchFilters } from './utils';

type Props = {
    portfolios: PORTFOLIO_RESPONSE_PAYLOAD;
};

const { dbCommercial, dashboard } = en;

const SwitchColumns: TableColumn[] = [
    { field: 'folio', headerName: 'Folio', width: 150 },
    {
        field: 'id',
        headerName: 'Scheme Name',
        fullWidth: true,
        valueGetter: ({ row }) => `${row?.schemeName}`,
        width: 350,
    },
    {
        field: 'availableAmount',
        headerName: 'Available Amount',
        valueGetter: ({ row }) => formatAsIndianCurrency(row?.availableAmount),
        width: 225,
    },
    {
        field: 'availableUnits',
        headerName: 'Available Units',
        valueGetter: ({ row }) => row?.availableUnits,
        width: 225,
    },
];

const Switch: React.FunctionComponent<Props> = (props) => {
    const [loading, setLoading] = useState<boolean>(true);
    const [rowData, setRowData] = useState<SCHEMES_RESPONSE[]>([]);
    const { portfolios } = props;
    const history = useHistory();
    const {
        selectedRows,
        setSelectedRows,
        resetTable,
        resetFilters,
        tableColumns,
        tableRows,
        ...filters
    } = useTableWithCollapse<SCHEMES_RESPONSE[]>({
        initialSelectionModal: [],
        rows: rowData,
        columns: SwitchColumns,
        loading,
    });
    const dispath = useDispatch();
    const nomineeErrorRef = useRef<NomineeStatusErrorRef>(null);

    useEffect(() => {
        setLoading(true);
        async function fetchPortfolio() {
            try {
                const res: any = await dispath(getPortfolio());
                const { data }: PORTFOLIO_RESPONSE_PAYLOAD = res.body;
                const schemeOptionsData = getDividendFilteredData(data);
                const _data = getMatchAndUnMatchedFunds(switchFilters, schemeOptionsData, true);
                setRowData(_data);
            } catch (err: any) {
                alert(err.message);
            } finally {
                setLoading(false);
            }
        }
        fetchPortfolio();
    }, []);

    const handleSubmit = async () => {
        const { amc, isin } = selectedRows[0];
        // if (![IsAllow.YES, "O"].includes(nomineeStatus.toUpperCase())) {
        //     nomineeErrorRef.current?.showNomineeError();
        // } else {
        history.push(`${CommercialRootPath}${SwitchPaths.SwitchTo}`, {
            switchFromScheme: selectedRows[0],
            data: tableRows.filter(
                (row) => !row.isDisabled && row.amc === amc && row.isin !== isin,
            ),
        });
        // }
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dbCommercial.switch.heading} />
            {/* <NomineeStatusError ref={nomineeErrorRef} /> */}
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table">
                    <>
                        <h5> {dbCommercial.switch.switchFromInfo}</h5>
                        {!!loading || tableRows.length ? (
                            <TableWithCollapse
                                rows={tableRows}
                                columns={tableColumns}
                                isRowSelectable={(params) => (params.row.isDisabled ? false : true)}
                                selectedRows={selectedRows}
                                setSelectedRows={setSelectedRows}
                                toolTipTextGetter={({ row }) => getErrorMessage(row, switchFilters)}
                                toolTipEnabled
                                radioGroupsEnabled
                                resetFilters={resetFilters}
                                {...filters}
                            />
                        ) : (
                            <NoFoliosFound info={dbCommercial.switch.errors.noFolios} />
                        )}
                    </>
                    <FaqLink section={SWITCH} />
                </div>
                <div className="curved-bg-content-inner-bottom">
                    {!!rowData.length && (
                        <div className="table-submit">
                            <Button
                                className="customBtn"
                                disabled={!selectedRows.length}
                                onClick={handleSubmit}
                            >
                                {dashboard.ChangeDividend.buttonText}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Switch;
